<template>
  <i
    v-if="fields.length"
    class="fas fa-exclamation-triangle text-danger missing-required-warning"
    :title="tooltip"
    :aria-label="tooltip"
    role="img"
  />
</template>

<script>
/**
 * Ticket #473 — triángulo al lado del nombre en el listado: al registro le faltan datos
 * obligatorios (se guardó con «Guardar de todos modos» o es de antes). Ver
 * utils/missingRequiredFields.js.
 *
 * Lo que falta lo calcula el listado (dynamic-model lo da por inject): así el ícono
 * sirve igual en la celda de solo lectura (text/viewField) y en la editable
 * (ListEditField). Fuera del listado no hay inject y no se muestra.
 */
export default {
  name: "MissingRequiredWarningIcon",
  inject: {
    listMissingRequiredFields: { default: null },
  },
  props: {
    /** Fila del listado. */
    item: {
      type: Object,
      default: null,
    },
  },
  computed: {
    fields() {
      if (typeof this.listMissingRequiredFields !== "function" || !this.item) {
        return [];
      }
      return this.listMissingRequiredFields(this.item);
    },
    tooltip() {
      const labels = this.fields
        .map((f) => this.$t(f.label || f.key))
        .join(", ");
      return this.$t("missingRequired.tooltip", { fields: labels });
    },
  },
};
</script>

<style scoped>
.missing-required-warning {
  font-size: 0.85em;
  cursor: help;
  flex-shrink: 0;
}
</style>
